module.exports = __webpack_public_path__ + "img/message-circle-02.069a799c.svg";